module.exports = __webpack_public_path__ + "static/pod-impact-11e917e61c0102df7c897c0ef19ec337.png";